import React from 'react';
import { Lead } from '../../types/lead.types';
import { SchoolSegment } from '../../types/project.types';
import { segmentPillClass, segmentDotClass } from '../../utils/segmentColors';

interface LeadSegmentPillProps {
  lead: Lead;
  /** The project's segments, used to resolve color/name. Falls back to the
   *  lead's denormalized schoolSegmentName when not provided. */
  segments?: SchoolSegment[];
  className?: string;
}

/**
 * Small campus pill for a lead in list views. Renders nothing when the lead has
 * no school segment, so it can be dropped in unconditionally.
 */
export const LeadSegmentPill: React.FC<LeadSegmentPillProps> = ({ lead, segments, className = '' }) => {
  if (!lead.schoolSegmentId && !lead.schoolSegmentName) return null;
  const seg = segments?.find(s => s.id === lead.schoolSegmentId);
  const name = seg?.name || lead.schoolSegmentName;
  if (!name) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-xs font-medium ${segmentPillClass(seg?.color)} ${className}`}
      title={`School: ${name}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${segmentDotClass(seg?.color)}`} />
      {name}
    </span>
  );
};
